import React from 'react';
import {Link} from 'react-router-dom';
import {getRouteUri} from '../../../../../helpers/getRouteUri';

export default function HeaderLogo() {
    return <Link to={getRouteUri('index', '/')} className="logo">
        <span className="logo-sm">CRM</span>
    </Link>;
}
